import React from 'react';
import './Error.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

interface ErrorProps {
    error: {
        message: string;
    };
}

export const Error = (props: ErrorProps): React.JSX.Element => {
    const { message } = props.error;

    const navigate = useNavigate();
    const navigateToMaintainence = () => {
        navigate(`/maintenance`);
    };

    if (message.indexOf('connect ECONNREFUSED') > -1) {
        navigateToMaintainence();
    } else {
        toast.error('There is an error while loading the data, please try again');
    }
    return <div></div>;
};
